module.exports = __webpack_public_path__ + "assets/images/premium-features/overtime-a585e1.png";